import { useLocalStorage } from './useLocalStorage'

export function useToken() {
  const [token, setToken, clearToken] = useLocalStorage('token', false)

  return { token, setToken, clearToken }
}
